<template>
    <div class="selection-list-container-div" v-loading="value.load">
        <div class="selection-list-wrap nano" v-if="value.content && value.content.length">
            <ul v-infinite-scroll="load" :infinite-scroll-distance="10" :infinite-scroll-delay="300"
                class="nano-content"
                ref="ulContent">
                <li v-for="(item, index) in value.content" :key="index" class="border-bottom">
                    <div class="li-div-content">
                        <div class="item-head">
                            <div class="item-head-left overflow-hidden-2">
                                <span class="cursor f16 font-weight-bold text-dark " @click="change(item)"
                                      :title="item.sourceAsMap.title"
                                      :class="{'head-text': item.sourceAsMap && (item.sourceAsMap.catName||item.sourceAsMap.type)}">
                                  {{item.sourceAsMap.title}}
                                </span>
                            </div>
                        </div>
                        <div v-if="item.sourceAsMap.modelType === 'data'" class="immte-chart">
                            <line-chart :chartdata="item.sourceAsMap.description"/>
                        </div>
                        <div class="overflow-hidden-1 desc-text" v-else>
                           <span>{{item.sourceAsMap.abs|| (item.sourceAsMap.description &&
                                item.sourceAsMap.description.split('|')[0])}}</span>
                        </div>
                        <div class="foot-message">
                           <span
                                   class="border border-warning text-warning f12 p11 text-span typeBtn"
                                   v-if="item.sourceAsMap && item.sourceAsMap.catName">
                             {{item.sourceAsMap.catName}}
                           </span>
                            <span
                                    class="border border-warning text-warning f12 p11 text-span"
                                    v-else-if="item.sourceAsMap && item.sourceAsMap.type">
                                 {{reportType[item.sourceAsMap.type]}}
                           </span>
                            <div class="time-long" v-if="item.sourceAsMap.modelType==='video'">
                              <span class="overflow-hidden-1">Duration:
                                <span class="time-long-text">{{'00:15'}}</span>
                              </span>
                                <span>|</span>
                            </div>
                            <span class="time overflow-hidden-1">{{timeTampToTime(item.sourceAsMap.published)}}</span>
                        </div>
                    </div>
                    <img-and-imgs
                            :src="item.sourceAsMap.thumb"
                            class="img-and-imgs"
                            v-if="item.sourceAsMap.modelType!=='data' && item.sourceAsMap.thumb">
                    </img-and-imgs>

                </li>
                <p class="text-center p-2 w-100" v-if="value.spaceLoadShow">
                    <i
                            class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
                <p class="text-center p-2 w-100" v-if="value.spaceEndShow">No more data...</p>
            </ul>
        </div>
        <div v-else class="nodata text-center">
            <img src="/static/images/no_data.png" alt/>
            <p style="color: #999999; padding-top: 20px">Sorry no data</p>
        </div>
    </div>
</template>

<script>
import MixinDateTime from '../mixins/dateTime'
import reportType from '../../search/utils/searchMap'
import LineChart from '@/views/asean/modules/invest/LineChart.vue'
import ImgAndImgs from './imgAndImgs'

export default {
  name: 'selectionList',
  mixins: [MixinDateTime],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          page: 1,
          size: 10,
          total: 0,
          pageCount: 0,
          content: [],
          spaceLoadShow: false,
          spaceEndShow: false
        }
      }
    },
    isKeep: {
      type: Boolean,
      default: true
    }
  },
  components: {
    LineChart,
    ImgAndImgs
  },
  data () {
    return {
      reportType: reportType.reportType,
      keepScrollTop: 0
    }
  },
  activated () {
    if (this.keepScrollTop && this.isKeep) {
      this.$nextTick(() => {
        this.$refs.ulContent.scrollTop = this.keepScrollTop
      })
    }
  },
  methods: {
    change (value) { // 跳转事件
      this.keepScrollTop = this.$refs.ulContent.scrollTop
      this.$emit('change', value)
    },
    load (val) {
      if (this.value.page === this.value.pageCount) {
        this.value.page = this.value.pageCount
        this.value.spaceEndShow = true
      } else {
        this.value.page += 1
        this.$emit('jumpList', false, this.value.page)
      }
    },
    scrollTop () {
      this.$refs.ulContent && (this.$refs.ulContent.scrollTop = 0)
    }
  }
}
</script>

<style scoped lang="less">
    .selection-list-container-div {
        width: 100%;
        height: 100%;
    }

    .typeBtn {
        flex-shrink: 0;
    }

    .selection-list-wrap {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .desc-text {
            padding-top: 9px;
            padding-bottom: 10px;
            color: #909399;
            font-size: 14px;

        }

        .text-warning {
            display: inline-block;
            margin: 0 8px 0 0;
            border-color: #409eff !important;
            color: #409eff !important;
        }

        .head-text {
            /*padding-left: 8px;*/
        }

        .text-dark {
            &:hover {
                color: #208EFF !important;
            }
        }

        ul {
            width: 100%;
            flex: 1;
            padding-left: 0;

            li {
                display: flex;
                align-items: center;
                margin: 4px 0;
                padding: 5px 0;

                .li-div-content {
                    flex: 1 1;
                    width: calc(100% - 135px);
                }

                .img-and-imgs {
                    flex-shrink: 1;
                    width: 116px;
                    height: 80px;
                    margin: 0 0 0 13px;
                }

                .immte-chart {
                    /deep/ #line-chart {
                        width: 100% !important;
                        height: 150px !important;
                    }
                }
            }
        }

        .list-pagination {
            width: 100%;
            text-align: center;
            padding: 0 0 21px 0;
            /*height: 50px;*/
        }
    }

    .item-head {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        .item-head-left {
            /*display: flex;*/
            align-items: center;
            flex: 1;
        }


        .time {
            margin-left: 12px;
            text-align: right;
            width: 80px;
            color: #909399;
            font-size: 14px;
        }
    }

    .foot-message {
        display: flex;
        align-items: center;

        .time-long {
            flex: 0 0;
            display: flex;
            font-size: 14px;
            color: #909399;
            margin: 0 4px 0 12px;

            .time-long-text {
                display: inline-block;
                margin: 0 3px 0 3px;
            }
        }
    }

    .overflow-hidden-1 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
